import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { CalculationSettingsModel, RNAVModel } from 'src/app/models/configuration';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { FeatureType } from 'src/app/models/EnumTypes';
import { PerformanceAnalysisDTO, PerformanceAnalysisDTOModal } from 'src/app/models/performanceAnalysisDTO';
import { ProcedureModel } from 'src/app/models/procedure';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { ProjectService } from 'src/app/services/project.service';
import { TabsService } from 'src/app/services/tabsService';
import { ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ProgressService } from 'src/app/services/progress.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'popup-performance-analysis',
  templateUrl: './performance-analysis.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class PopupPerformanceAnalysisComponent implements OnInit {

  @Input() performanceAnalysisDTO : PerformanceAnalysisDTO;
  @Input() selectedProcedure : ProcedureModel;

  performanceAnalysisDTOModal : PerformanceAnalysisDTOModal =  new PerformanceAnalysisDTOModal();
  
  selectedAirport: CoordinatePointModel;
  form : FormGroup;
  readonly forbiddenSubstringName = TabsService.SEPARATOR;

  constructor(
    private http: HttpClient,
     private pointsService : PointsService,
     private mapService:MapService,
     private configurationService : ConfigurationService,
     private endpointsService: EndpointsService,
     public bsModalRef : BsModalRef,
     public modalService: ModalControlService,
     public calculationService : CalculationsService,
     public projectController : ProjectService,
     private changeDetector : ChangeDetectorRef,
     ) {
      this.performanceAnalysisDTOModal =  new PerformanceAnalysisDTOModal();
   }

  ngOnInit(): void {
    this.selectedProcedure = cloneDeep(this.pointsService.selectedProcedure);
    this.pointsService.selectedProcedure = null;
    this.form = new FormGroup({
      calculationName: new FormControl(this.performanceAnalysisDTOModal.calculationName)
    })
  }

  cancelPerformanceAnalysis():void{
    this.bsModalRef.hide();
  }

  performanceAnalysisCalculation(){
    this.bsModalRef.hide();
    this.performanceAnalysisDTO.name = this.performanceAnalysisDTOModal.calculationName;
    this.performanceAnalysisDTO.aircraftSpeed = this.selectedProcedure.aircraftspeed;
    this.performanceAnalysisDTO.runwayUpdateValue = this.performanceAnalysisDTOModal.runwayUpdateError;
    this.performanceAnalysisDTO.inertialDrift = this.performanceAnalysisDTOModal.inertialDrift;
    this.performanceAnalysisDTO.maxAllowedNSE = this.performanceAnalysisDTOModal.maxAllowedNSE;
    this.performanceAnalysisDTO.isInertialDrift = this.performanceAnalysisDTOModal.isInertial;
    this.performanceAnalysisDTO.performanceType = parseInt(this.performanceAnalysisDTOModal.processingtype || "1");
    if(this.performanceAnalysisDTOModal.isInertial){
      this.calculationService.displayCalculation.displayWorstInertialChart = true;
      this.calculationService.displayCalculation.displayCenterInertialChart = true;
    }else {
      this.calculationService.displayCalculation.displayWorstInertialChart = false;
      this.calculationService.displayCalculation.displayCenterInertialChart = false;
    }

    this.changeDetector.detectChanges();
    this.performanceAnalysisDTO.receiverDelay = this.performanceAnalysisDTOModal.receiverDelay;
    this.performanceAnalysisDTO.projectId = this.projectController.activeProject.id;
    if(this.selectedAirport != null){
      this.performanceAnalysisDTO.referenceairportLatitude = this.selectedAirport.latitude;
      this.performanceAnalysisDTO.referenceairportLongitude = this.selectedAirport.longitude;
    }

    this.performanceAnalysisDTO.resultanalysis = this.performanceAnalysisDTOModal.resultanalysis;
    this.performanceAnalysisDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    this.performanceAnalysisDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);


    this.mapService.clearSelections();


    this.performanceAnalysisDTO.calculationSettings.geometricConstraints = true;
    this.http
      .post(
        this.endpointsService.performanceAnalysisUrl,
        this.performanceAnalysisDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.calculationService.showError(error)
        }
      );


  }
  changeReceiverDelayStatus() : void {
    switch (this.performanceAnalysisDTOModal.processingtype) {
      case '0':
        this.performanceAnalysisDTOModal.isReceiverDelayEnable = false;
        this.performanceAnalysisDTOModal.receiverDelay = false;
        break;
      case '1':
        this.performanceAnalysisDTOModal.isReceiverDelayEnable = false;
        this.performanceAnalysisDTOModal.receiverDelay = true;
        break;
      case '2':
        this.performanceAnalysisDTOModal.isReceiverDelayEnable = true;
        break;
    }
  }
}
